import { PRODUCTS_FILTERS } from 'frontend/constants/filterUrls'
import { SETTINGS_CARDS_TOKENS } from 'frontend/constants/settings'

const RemoteFilters = () => import('frontcore/presentation/remote-filters/views/RemoteFilters.vue')
const SettingsProductionHierarchyPage = () => import('frontend/pages/settings/productionHierarchy/SettingsProductionHierarchyPage')
const SettingsProductionHierarchyDetailsPage = () => import('frontend/pages/settings/productionHierarchy/SettingsProductionHierarchyDetails')

export function createNewRoutesProductionHierarchy (productionHierarchy) {
  const detailsRoutes = productionHierarchy.map(item => {
    return {
      path: `${SETTINGS_CARDS_TOKENS.productionHierarchyDetails.name(item.name)}/:id`,
      name: SETTINGS_CARDS_TOKENS.productionHierarchyDetails.name(item.name),
      component: SettingsProductionHierarchyDetailsPage,
    }
  })
  const definitionRoutes = productionHierarchy.map(item => {
    return {
      path: SETTINGS_CARDS_TOKENS.productionHierarchyDefinition.name(item.name),
      name: SETTINGS_CARDS_TOKENS.productionHierarchyDefinition.name(item.name),
      components: {
        default: SettingsProductionHierarchyPage,
        filters: RemoteFilters,
      },
      props: {
        default: { levelId: item.name, level: item.level },
        filters: { filterURL: PRODUCTS_FILTERS },
      },
    }
  })

  return detailsRoutes.concat(definitionRoutes)
}
